export type StockDirection = 'UP' | 'DOWN';

export interface StockTicker {
  symbol: string;
  direction: StockDirection;
  id: string;
}

export interface GameRound {
  stocks: StockTicker[];
  playerAnswers: { [stockSymbol: string]: StockDirection };
  startTime: number;
  endTime?: number;
  accuracy: number;
}

export interface DifficultySettings {
  stockCount: number;
  scrollSpeed: number; // pixels per second
  displayTime: number; // seconds to show tickers
}

export interface TickerTapeGameState {
  phase: 'instructions' | 'watching' | 'recalling' | 'result';
  currentRound: number;
  stocks: StockTicker[];
  playerAnswers: { [stockSymbol: string]: StockDirection };
  timeLeft: number;
  difficulty: DifficultySettings;
  isComplete: boolean;
  rounds: GameRound[];
  totalAccuracy: number;
  levelStartTime?: number; // Track when level started
}

export interface GameStats {
  timestamp: string;
  totalRounds: number;
  averageAccuracy: number;
  finalDifficulty: DifficultySettings;
  totalTimeSeconds: number;
}

// Stock symbols for the game
export const STOCK_SYMBOLS = [
  'AAPL', 'TSLA', 'MSFT', 'GOOGL', 'AMZN', 
  'META', 'NVDA', 'NFLX', 'UBER', 'SPOT'
];

// DDA Configuration
export const DDA_CONFIG = {
  ACCURACY_HIGH_THRESHOLD: 0.85,    // 85%+ to increase (harder to advance)
  ACCURACY_LOW_THRESHOLD: 0.60,     // <60% to decrease (easier relief)
  DIFFICULTY_INCREASE: {
    stockCountIncrease: 1,          // Gradual increase
    speedMultiplier: 1.1            // Smaller speed bump (easier)
  },
  DIFFICULTY_DECREASE: {
    stockCountDecrease: 1,          // Gradual decrease
    speedMultiplier: 0.80           // Larger speed reduction (easier relief)
  },
  MIN_STOCKS: 3,                    // Start easy
  MAX_STOCKS: 10,                   // Reduced max (easier)
  MIN_SPEED: 25,                    // Even slower minimum (easier)
  MAX_SPEED: 100                    // Reduced max speed (easier)
};

// Initial game settings
export const INITIAL_DIFFICULTY: DifficultySettings = {
  stockCount: 3,                    // Start with only 3 stocks (easier)
  scrollSpeed: 30,                  // Even slower speed (easier)
  displayTime: 12                   // More display time (easier)
};